export enum RevisionStateType {
  LATEST = 'LATEST',
  NOT_LATEST = 'NOT_LATEST',
  ANY = 'ANY'
}

export class RevisionState {
  public name: RevisionStateType;
  private acceptsLatest: boolean;
  private acceptsNotLatest: boolean;

  constructor(name: RevisionStateType) {
    this.name = name;
    this.acceptsLatest = name === RevisionStateType.LATEST || name === RevisionStateType.ANY;
    this.acceptsNotLatest = name === RevisionStateType.NOT_LATEST || name === RevisionStateType.ANY;
  }

  public handleRevisionPermissions(isLatestRevision: boolean): boolean {
    return isLatestRevision ? this.acceptsLatest : this.acceptsNotLatest;
  }
}
